import axios from "axios";
import * as Sentry from "@sentry/nextjs";

const reportApiError = (error) => {
  Sentry.withScope((scope) => {
    const backendTraceId = error.response.headers["x-sentry-trace-id"];
    if (backendTraceId) {
      scope.setTag("linked_trace_id", backendTraceId);
    }
    scope.setTag("api_endpoint", error.config.url);
    scope.setExtra("page", window.location.href);
    Sentry.captureException(
      new Error(`API Response: ${error.response.status} ${error.config.url}`),
    );
  });
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const axiosInstance = axios.create({
  timeout: parseInt(process.env.NEXT_PUBLIC_GLOBAL_API_TIMEOUT) || 0,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = getCookie("XSRF-TOKEN");
  if (token) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Handle unauthorized
          break;
        case 404:
          // Handle not found
          break;
        case 500:
          reportApiError(error);
          break;
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
